import { combineReducers } from 'redux';
import {
  SELECT_NETWORK,
  SET_INITIALIZING
} from '../actions';

const initState = {
  initializing: false
};

const global = (state = initState, action) => {
  switch (action.type) {
    case SET_INITIALIZING:
      return { ...state, initializing: action.value };
    default:
      return state;
  }
};

const initialState = {
  search: { status: null, query: '' },
  editing: null,
  open: null
};

const teams = (state = initialState, action) => {
  switch (action.type) {
    case SELECT_NETWORK:
      return initialState;
    default: return state;
  }
};

export default combineReducers({ teams, global });
